import React, { Component } from "react"

class Spinner extends Component {
  render() {
    return (
      <div className={`loader js--ajax-loader ${this.props.isActive ? "is-active" : ""} ${this.props.isTransparent ? "loader--transparent" : ""}`}>
        <div className="spinner" />
        {this.props.pleaseWaitText ? <p className={"please-wait"}>{this.props.pleaseWaitText}</p> : ""}
      </div>
    )
  }
}
export default Spinner
